import type { TFunction } from "i18next";

/** Incomplete public invoice snapshots from the API are status-only and have no total. */
export type StatusOnlyPublicInvoiceDocument = {
  status?: string | null;
  billing_profile?: undefined;
};

export function isRenderablePublicInvoiceDocument<
  TInvoiceData extends { total?: unknown | null },
>(
  documentData: StatusOnlyPublicInvoiceDocument | TInvoiceData
): documentData is TInvoiceData {
  return "total" in documentData && documentData.total != null;
}

export function getIncompletePublicInvoiceMessage(
  status: string | null | undefined,
  t: TFunction
): string {
  if (status === "FAILED_GENERATION") {
    return t("This invoice could not be generated.");
  }
  if (status === "PROCESSING") {
    return t("This invoice is still being generated.");
  }
  return t("This invoice is not available yet.");
}
